import React from 'react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-white text-white overflow-hidden">
      {/* Background Image - Fixed to right side */}
      <div className="absolute right-0 bottom-0 z-0 h-full w-auto max-w-[50%] hidden lg:block">
        <img 
          src="/images/heroDuenas.png" 
          alt="Profesionales SP Asociados" 
          className="h-full w-auto object-contain object-right-bottom"
        />
      </div>

      {/* Mobile Background Image - Full width */}
      <div className="absolute bottom-0 left-0 right-0 z-0 lg:hidden h-[60%]">
        <img 
          src="/images/heroDuenas.png" 
          alt="Profesionales SP Asociados" 
          className="h-full w-full object-contain object-bottom"
        />
      </div>

      {/* Gradient Overlay - Desktop horizontal, Mobile vertical */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050835] from-10% via-[#050835]/70 via-50% to-transparent lg:bg-gradient-to-r lg:from-[#050835] lg:via-[#050835]/90 lg:to-transparent z-10"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-20 max-w-[1512px]">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center h-[860px]">
          {/* Content */}
          <div className="text-center lg:text-left ml-2 lg:ml-6 2xl:ml-0">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold leading-tight mb-6">
              Alcanzamos tus objetivos empresariales
            </h1>
            <div className="flex gap-4 justify-center lg:justify-start">
              <button
                onClick={() => scrollToSection('contacto')}
                className="border-2 border-white text-white hover:bg-white hover:text-[#001580] px-6 py-3 rounded-lg font-semibold transition-all duration-200 whitespace-nowrap"
              >
                Contáctanos
              </button>
              <button
                onClick={() => scrollToSection('servicios')}
                className="bg-white text-[#001580] hover:bg-gray-100 px-6 py-3 rounded-lg font-semibold transition-all duration-200 shadow-lg whitespace-nowrap"
              >
                Ver servicios
              </button>
            </div>
          </div>

          {/* Empty space for image */}
          <div></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
